/**
 * Disables incompatible supply attribute options in Budget Cap / % Allocation breakdowns.
 * Same attribute type may appear on multiple rows (e.g. two Publisher ID lines with different values);
 * server validation rejects overlapping values, not duplicate types.
 */

const TOOLTIP_MESSAGE = 'Cannot be combined with selected supply attributes';

function optionIncompatibleObjects(optionEl) {
  const raw = $(optionEl).data('incompatible-objects');
  if (!raw) {
    return [];
  }

  if (Array.isArray(raw)) {
    return raw;
  }

  if (typeof raw === 'string') {
    return raw.split(/\s+/).filter(Boolean);
  }

  return [];
}

function selectedValuesExcludingRow($selects, $currentSelect) {
  const values = [];
  $selects.each(function() {
    if (this === $currentSelect.get(0)) {
      return;
    }
    const v = $(this).val();
    if (v) {
      values.push(v);
    }
  });
  return values;
}

function refreshGroupedAssociation($groupedAssociations) {
  const $selects = $groupedAssociations.find('.budget-cap-allocation-object select');
  if (!$selects.length) {
    return;
  }

  $selects.each(function() {
    const $select = $(this);
    const selectedElsewhere = selectedValuesExcludingRow($selects, $select);

    $select.find('option').each(function() {
      const $opt = $(this);
      const val = $opt.attr('value');
      if (!val) {
        $opt.prop('disabled', false).removeAttr('title');
        return;
      }

      if ($opt.is(':selected')) {
        $opt.prop('disabled', false).removeAttr('title');
        return;
      }

      const incompatibleObjects = optionIncompatibleObjects(this);
      const incompatible = incompatibleObjects.some(function(v) {
        return selectedElsewhere.includes(v);
      });

      if (incompatible) {
        $opt.prop('disabled', true).attr('title', TOOLTIP_MESSAGE);
      } else {
        $opt.prop('disabled', false).removeAttr('title');
      }
    });

    $select.trigger('chosen:updated');
  });
}

export function refreshBudgetAllocationAttributeDisables(scope) {
  const $scope = scope && scope.length ? scope : $('body');
  const $groups = $scope.is('.groupedAssociations') ? $scope : $scope.find('.groupedAssociations');

  $groups.each(function() {
    const $group = $(this);
    if (!$group.closest('.budget-cap-card, .budget-allocation-card').length) {
      return;
    }

    refreshGroupedAssociation($group);
  });
}
